// === SVG 衣物图标生成器 ===
import type { Item, Outfit, SvgPattern } from './types';

function svg(inner: string): string {
  return `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" class="garment-svg">${inner}</svg>`;
}

function pattern(name: SvgPattern, c1: string, c2: string): string {
  if (name === 'stripe') {
    return `<pattern id="pat" width="10" height="10" patternUnits="userSpaceOnUse">
      <rect width="10" height="10" fill="${c1}"/>
      <path d="M0,5 L10,5" stroke="${c2}" stroke-width="2"/>
    </pattern>`;
  }
  if (name === 'dot') {
    return `<pattern id="pat" width="14" height="14" patternUnits="userSpaceOnUse">
      <rect width="14" height="14" fill="${c1}"/>
      <circle cx="7" cy="7" r="2" fill="${c2}"/>
    </pattern>`;
  }
  if (name === 'check') {
    return `<pattern id="pat" width="20" height="20" patternUnits="userSpaceOnUse">
      <rect width="20" height="20" fill="${c1}"/>
      <rect width="10" height="10" fill="${c2}" opacity="0.5"/>
      <rect x="10" y="10" width="10" height="10" fill="${c2}" opacity="0.5"/>
    </pattern>`;
  }
  return '';
}

type SvgFn = (c1: string, c2?: string, pat?: SvgPattern) => string;

export const SVG: Record<string, SvgFn> = {
  top: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M60,40 L100,20 L140,40 L170,55 L155,90 L140,80 L140,180 L60,180 L60,80 L45,90 L30,55 Z"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2" stroke-linejoin="round"/>
    <path d="M100,22 Q100,42 100,55" fill="none" stroke="#1a1816" stroke-width="1.4" opacity="0.5"/>
  `),
  bottom: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M55,30 L145,30 L150,90 L130,180 L110,180 L100,100 L90,180 L70,180 L50,90 Z"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2" stroke-linejoin="round"/>
    <line x1="100" y1="35" x2="100" y2="100" stroke="#1a1816" stroke-width="1" opacity="0.4"/>
  `),
  dress: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M65,35 L100,18 L135,35 L160,55 L145,80 L135,75 L155,180 L45,180 L65,75 L55,80 L40,55 Z"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2" stroke-linejoin="round"/>
    <path d="M100,20 Q100,50 100,70" fill="none" stroke="#1a1816" stroke-width="1.3" opacity="0.5"/>
  `),
  outerwear: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M55,38 L95,18 L100,30 L105,18 L145,38 L175,55 L160,95 L145,85 L145,182 L100,182 L55,182 L55,85 L40,95 L25,55 Z"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2" stroke-linejoin="round"/>
    <line x1="100" y1="30" x2="100" y2="180" stroke="#1a1816" stroke-width="1.5" opacity="0.7"/>
    <circle cx="100" cy="60" r="2.5" fill="#1a1816"/>
    <circle cx="100" cy="100" r="2.5" fill="#1a1816"/>
    <circle cx="100" cy="140" r="2.5" fill="#1a1816"/>
  `),
  shoes: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M30,130 Q35,100 70,95 Q120,90 160,110 Q175,115 175,130 L175,150 L30,150 Z"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2" stroke-linejoin="round"/>
    <path d="M30,148 L175,148" stroke="#1a1816" stroke-width="3" opacity="0.8"/>
  `),
  bag: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <path d="M70,60 Q70,30 100,30 Q130,30 130,60" fill="none" stroke="#1a1816" stroke-width="3"/>
    <rect x="50" y="60" width="100" height="100" rx="8"
          fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2"/>
    <circle cx="100" cy="100" r="4" fill="#1a1816"/>
  `),
  accessory: (c1) => svg(`
    <circle cx="100" cy="100" r="55" fill="none" stroke="${c1}" stroke-width="6"/>
    <circle cx="100" cy="50" r="6" fill="${c1}" stroke="#1a1816" stroke-width="1.5"/>
  `),
  hat: (c1, c2 = '#fff', pat = 'solid') => svg(`
    <defs>${pattern(pat, c1, c2)}</defs>
    <ellipse cx="100" cy="130" rx="80" ry="14" fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2"/>
    <path d="M50,130 Q50,60 100,55 Q150,60 150,130 Z" fill="${pat === 'solid' ? c1 : 'url(#pat)'}" stroke="#1a1816" stroke-width="2"/>
    <ellipse cx="100" cy="130" rx="50" ry="6" fill="#1a1816" opacity="0.2"/>
  `),
};

// === 标签词典 ===
export const TAGS = {
  category: ['上衣', '下装', '连衣裙', '外套', '鞋履', '包袋', '配饰', '帽子'],
  occasion: ['通勤', '约会', '休闲', '正式', '度假', '运动'],
  season:   ['春', '夏', '秋', '冬'],
  style:    ['极简', '复古', '甜酷', '法式', '街头', '学院', '日杂', '都市'],
  color:    ['白', '黑', '米', '驼', '咖', '灰', '蓝', '牛仔', '红', '粉', '绿', '黄'],
} as const;

export const COLOR_HEX: Record<string, string> = {
  '白':'#f8f6ef','黑':'#1a1816','米':'#e8dfc7','驼':'#c19877','咖':'#6b4a32',
  '灰':'#9b988f','蓝':'#3d5a80','牛仔':'#4a6a8a','红':'#a8442d','粉':'#e8b3a8',
  '绿':'#5a7a5e','黄':'#d4a72c'
};

// === 单品 ===
export const ITEMS: Item[] = [
  // 上衣
  { id:'t-white-tee',     name:'白色基础 T 恤',    cat:'上衣',   color:'白',  style:['极简','日杂','街头'], season:['春','夏','秋'], occasion:['休闲','约会'], price:189, render:() => SVG.top!(COLOR_HEX['白']!) },
  { id:'t-black-tee',     name:'黑色丝光棉 T',     cat:'上衣',   color:'黑',  style:['极简','街头','都市'], season:['春','夏','秋'], occasion:['休闲','通勤'], price:229, render:() => SVG.top!(COLOR_HEX['黑']!) },
  { id:'t-stripe-tee',    name:'蓝白条纹海魂衫',   cat:'上衣',   color:'蓝',  style:['法式','日杂'],        season:['春','夏','秋'], occasion:['休闲','度假'], price:259, render:() => SVG.top!(COLOR_HEX['白']!, COLOR_HEX['蓝']!, 'stripe') },
  { id:'t-beige-knit',    name:'米色细针织衫',     cat:'上衣',   color:'米',  style:['极简','法式','学院'],season:['秋','冬'],     occasion:['通勤','约会'], price:399, render:() => SVG.top!(COLOR_HEX['米']!) },
  { id:'t-pink-blouse',   name:'樱粉雪纺衬衫',     cat:'上衣',   color:'粉',  style:['法式','甜酷'],        season:['春','夏'],     occasion:['约会','通勤'], price:329, render:() => SVG.top!(COLOR_HEX['粉']!) },

  // 下装
  { id:'b-jeans-blue',    name:'蓝色直筒牛仔裤',   cat:'下装',   color:'牛仔',style:['街头','日杂','都市'],season:['春','秋','冬'],occasion:['休闲','约会'], price:469, render:() => SVG.bottom!(COLOR_HEX['牛仔']!) },
  { id:'b-black-trouser', name:'黑色西装直筒裤',   cat:'下装',   color:'黑',  style:['极简','都市'],        season:['春','秋','冬'],occasion:['通勤','正式'], price:599, render:() => SVG.bottom!(COLOR_HEX['黑']!) },
  { id:'b-cream-skirt',   name:'米色 A 字半裙',    cat:'下装',   color:'米',  style:['法式','学院'],        season:['春','夏','秋'],occasion:['约会','通勤'], price:389, render:() => SVG.bottom!(COLOR_HEX['米']!) },
  { id:'b-check-skirt',   name:'格纹百褶短裙',     cat:'下装',   color:'咖',  style:['学院','复古'],        season:['秋','冬'],     occasion:['约会','休闲'], price:359, render:() => SVG.bottom!(COLOR_HEX['咖']!, COLOR_HEX['黑']!, 'check') },

  // 连衣裙
  { id:'d-white-slip',    name:'白色吊带丝缎裙',   cat:'连衣裙', color:'白',  style:['法式','极简'],        season:['夏'],         occasion:['约会','度假'], price:529, render:() => SVG.dress!(COLOR_HEX['白']!) },
  { id:'d-black-mini',    name:'黑色小黑裙',       cat:'连衣裙', color:'黑',  style:['都市','极简'],        season:['春','夏','秋'],occasion:['约会','正式'], price:699, render:() => SVG.dress!(COLOR_HEX['黑']!) },
  { id:'d-floral',        name:'碎花茶歇裙',       cat:'连衣裙', color:'粉',  style:['法式','日杂','甜酷'],season:['春','夏'],     occasion:['约会','度假'], price:489, render:() => SVG.dress!(COLOR_HEX['粉']!, COLOR_HEX['白']!, 'dot') },

  // 外套
  { id:'o-camel-coat',    name:'驼色羊毛大衣',     cat:'外套',   color:'驼',  style:['极简','法式','都市'],season:['秋','冬'],     occasion:['通勤','约会'], price:1899, render:() => SVG.outerwear!(COLOR_HEX['驼']!) },
  { id:'o-trench',        name:'卡其风衣',         cat:'外套',   color:'米',  style:['复古','法式','都市'],season:['春','秋'],     occasion:['通勤','约会'], price:1599, render:() => SVG.outerwear!(COLOR_HEX['米']!) },
  { id:'o-denim-jacket',  name:'蓝色牛仔外套',     cat:'外套',   color:'牛仔',style:['街头','日杂'],        season:['春','秋'],     occasion:['休闲','约会'], price:599, render:() => SVG.outerwear!(COLOR_HEX['牛仔']!) },
  { id:'o-blazer-black',  name:'黑色廓形西装',     cat:'外套',   color:'黑',  style:['都市','极简'],        season:['春','秋'],     occasion:['通勤','正式'], price:1299, render:() => SVG.outerwear!(COLOR_HEX['黑']!) },

  // 鞋
  { id:'s-white-sneaker', name:'白色小白鞋',       cat:'鞋履',   color:'白',  style:['街头','日杂','极简','学院'],season:['春','夏','秋'],occasion:['休闲','运动'], price:599, render:() => SVG.shoes!(COLOR_HEX['白']!) },
  { id:'s-black-loafer',  name:'黑色乐福鞋',       cat:'鞋履',   color:'黑',  style:['学院','法式','都市'],season:['春','秋','冬'],occasion:['通勤','约会'], price:799, render:() => SVG.shoes!(COLOR_HEX['黑']!) },
  { id:'s-brown-boot',    name:'咖色切尔西靴',     cat:'鞋履',   color:'咖',  style:['复古','街头','都市'],season:['秋','冬'],     occasion:['休闲','通勤'], price:999, render:() => SVG.shoes!(COLOR_HEX['咖']!) },
  { id:'s-red-mary',      name:'红色玛丽珍鞋',     cat:'鞋履',   color:'红',  style:['复古','甜酷','法式'],season:['春','秋'],     occasion:['约会','正式'], price:899, render:() => SVG.shoes!(COLOR_HEX['红']!) },

  // 包
  { id:'g-black-bag',     name:'黑色机车包',       cat:'包袋',   color:'黑',  style:['都市','街头'],        season:['春','夏','秋','冬'], occasion:['通勤','休闲'], price:1299, render:() => SVG.bag!(COLOR_HEX['黑']!) },
  { id:'g-camel-tote',    name:'驼色托特包',       cat:'包袋',   color:'驼',  style:['极简','法式','学院'],season:['春','夏','秋','冬'], occasion:['通勤','休闲'], price:899, render:() => SVG.bag!(COLOR_HEX['驼']!) },
  { id:'g-pink-mini',     name:'粉色迷你斜挎',     cat:'包袋',   color:'粉',  style:['甜酷','法式'],        season:['春','夏'],         occasion:['约会','度假'], price:699, render:() => SVG.bag!(COLOR_HEX['粉']!) },

  // 配饰
  { id:'a-gold-hoop',     name:'金色简约耳环',     cat:'配饰',   color:'黄',  style:['法式','极简','都市'],season:['春','夏','秋','冬'], occasion:['通勤','约会'], price:259, render:() => SVG.accessory!(COLOR_HEX['黄']!) },
  { id:'a-pearl',         name:'珍珠项链',         cat:'配饰',   color:'白',  style:['复古','法式','学院'],season:['春','夏','秋','冬'], occasion:['约会','正式'], price:459, render:() => SVG.accessory!(COLOR_HEX['白']!) },

  // 帽子
  { id:'h-black-cap',     name:'黑色棒球帽',       cat:'帽子',   color:'黑',  style:['街头','日杂'],        season:['春','夏','秋'],   occasion:['休闲','运动'], price:259, render:() => SVG.hat!(COLOR_HEX['黑']!) },
  { id:'h-straw-hat',     name:'草编宽檐帽',       cat:'帽子',   color:'米',  style:['法式','日杂'],        season:['夏'],             occasion:['度假','约会'], price:329, render:() => SVG.hat!(COLOR_HEX['米']!) },
];

export const ITEM_BY_ID: Record<string, Item> = Object.fromEntries(ITEMS.map(i => [i.id, i]));

// === 策划好的搭配 ===
export const OUTFITS: Outfit[] = [
  { id:'fit-1',  title:'巴黎周末',     desc:'海魂衫 + 直筒牛仔 + 乐福鞋,法式女孩的休日标配。',
    pieces:['t-stripe-tee','b-jeans-blue','s-black-loafer','g-camel-tote'], style:'法式', season:'春', occasion:'休闲' },
  { id:'fit-2',  title:'极简通勤',     desc:'米色针织 + 西装裤 + 驼色大衣,温柔利落两不误。',
    pieces:['t-beige-knit','b-black-trouser','o-camel-coat','s-black-loafer','g-camel-tote'], style:'极简', season:'秋', occasion:'通勤' },
  { id:'fit-3',  title:'初夏约会',     desc:'白色丝缎吊带裙 + 玛丽珍鞋 + 草编帽,慵懒的浪漫。',
    pieces:['d-white-slip','s-red-mary','h-straw-hat','a-pearl'], style:'法式', season:'夏', occasion:'约会' },
  { id:'fit-4',  title:'城市少年',     desc:'黑 T + 牛仔外套 + 直筒裤 + 小白鞋,永不过时的街头公式。',
    pieces:['t-black-tee','o-denim-jacket','b-jeans-blue','s-white-sneaker','h-black-cap'], style:'街头', season:'春', occasion:'休闲' },
  { id:'fit-5',  title:'学院少女',     desc:'格纹短裙 + 米色针织 + 咖色靴,秋天的复古情绪。',
    pieces:['t-beige-knit','b-check-skirt','s-brown-boot','a-pearl'], style:'学院', season:'秋', occasion:'约会' },
  { id:'fit-6',  title:'正式晚宴',     desc:'小黑裙 + 廓形西装 + 玛丽珍 + 珍珠,优雅永远不会错。',
    pieces:['d-black-mini','o-blazer-black','s-red-mary','a-pearl','g-black-bag'], style:'都市', season:'春', occasion:'正式' },
  { id:'fit-7',  title:'海岛度假',     desc:'碎花裙 + 草编帽 + 粉色斜挎,阳光气息直接拉满。',
    pieces:['d-floral','h-straw-hat','g-pink-mini','s-red-mary'], style:'日杂', season:'夏', occasion:'度假' },
  { id:'fit-8',  title:'米兰编辑部',   desc:'樱粉衬衫 + A 字裙 + 风衣,有少女气也有掌控力。',
    pieces:['t-pink-blouse','b-cream-skirt','o-trench','s-black-loafer','g-camel-tote'], style:'法式', season:'春', occasion:'通勤' },
  { id:'fit-9',  title:'雨天书店',     desc:'白 T + 黑色西装裤 + 切尔西靴,极简里的故事感。',
    pieces:['t-white-tee','b-black-trouser','o-trench','s-brown-boot'], style:'极简', season:'秋', occasion:'通勤' },
  { id:'fit-10', title:'日杂女孩',     desc:'格纹裙 + 牛仔外套 + 小白鞋 + 棒球帽,松弛的日常感。',
    pieces:['b-check-skirt','o-denim-jacket','t-white-tee','s-white-sneaker','h-black-cap'], style:'日杂', season:'秋', occasion:'休闲' },
  { id:'fit-11', title:'金色小巴黎',   desc:'米色针织 + 牛仔裤 + 金色耳环 + 驼色托特,简单里见品味。',
    pieces:['t-beige-knit','b-jeans-blue','a-gold-hoop','g-camel-tote','s-white-sneaker'], style:'法式', season:'春', occasion:'休闲' },
  { id:'fit-12', title:'夏夜慢跑',     desc:'白 T + 黑色棒球帽 + 小白鞋,运动的轻便感。',
    pieces:['t-white-tee','b-jeans-blue','h-black-cap','s-white-sneaker'], style:'街头', season:'夏', occasion:'运动' },
];

// === 色彩协调评分(prototype 用经验值) ===
const COLOR_FAMILY: Record<string, 'neutral' | 'warm' | 'cool'> = {
  '白':'neutral','黑':'neutral','灰':'neutral','米':'neutral','驼':'warm','咖':'warm',
  '蓝':'cool','牛仔':'cool','红':'warm','粉':'warm','绿':'cool','黄':'warm'
};

export function colorScore(a: string, b: string): number {
  if (a === b) return 0.6;
  if (COLOR_FAMILY[a] === 'neutral' || COLOR_FAMILY[b] === 'neutral') return 1.0;
  if (COLOR_FAMILY[a] === COLOR_FAMILY[b]) return 0.85;
  return 0.5;
}
